// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CartContext } from "@insite/client-framework/Components/CartContext";
import { updateCart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DynamicDropdown, { OptionObject } from "@insite/mobius/DynamicDropdown";
import filter from "@insite/mobius/DynamicDropdown/filter";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useApprovers from "@store/Framework/Store/Data/OrderApprovals/useApprovers";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { useContext, useEffect, useState } from "react";
import { css } from "styled-components";

export interface OrderApprovalDetailsUpdateApproverProps
    extends ExpandStyles<OrderApprovalDetailsUpdateApproverStyles> {}

export interface OrderApprovalDetailsUpdateApproverStyles {
    wrapper?: InjectableCss;
    submitButton?: ButtonPresentationProps;
}

export const orderApprovalDetailsUpdateApproverStyles: OrderApprovalDetailsUpdateApproverStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 1rem;
            width: 100%;
        `,
    },
};

const OrderApprovalDetailsUpdateApprover = ({
    extendedStyles,
    overridedStyles,
}: OrderApprovalDetailsUpdateApproverProps) => {
    const toasterContext = useContext(ToasterContext);
    const isDisabled = useAppSelector(state => state.pages.checkoutReviewAndSubmit.isPlacingOrder);
    const cart = useContext(CartContext);
    const styles = useExpandProps(orderApprovalDetailsUpdateApproverStyles, extendedStyles, overridedStyles);

    if (!cart) {
        return null;
    }

    const { options } = useApprovers(cart);
    const [approverId, setApproverId] = useState(cart.properties?.currentApproverId);

    const handleSelectionChange = (newApproverId?: string) => {
        if (!newApproverId) {
            return;
        }
        setApproverId(newApproverId);
    };

    const handleClick = async () => {
        try {
            await updateCart({
                cart: {
                    ...cart,
                    properties: {
                        ...cart.properties,
                        approverId,
                    },
                } as CartModel,
            });
            toasterContext.addToast({
                body: translate("OrderApproval_UpdateSuccessMessage"),
                messageType: "success",
            });
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        } catch (error) {
            toasterContext.addToast({
                body: translate("OrderApproval_UpdateErrorMessage"),
                messageType: "danger",
            });
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <DynamicDropdown
                label={translate("Select An Approver")}
                options={options}
                placeholder={translate("OrderApproval_DropDownPlaceholder")}
                filterOption={filter}
                onSelectionChange={handleSelectionChange}
                selected={approverId}
            />
            <Button
                type="submit"
                disabled={isDisabled || !approverId}
                data-test-selector="orderApprovalDetails_updateApprover"
                {...styles.submitButton}
                onClick={handleClick}
            >
                {translate("OrderApproval_UpdateApproverButtonLabel")}
            </Button>
        </StyledWrapper>
    );
};

export default OrderApprovalDetailsUpdateApprover;
